import api from './client';

export const getExpenseDashboard = () => api.get('/expenses/dashboard');
export const getExpenseInsights = () => api.get('/expenses/insights');
export const getExpenseReports = (params) => api.get('/expenses/reports', { params });

// Transactions
export const listTransactions = (params) => api.get('/expenses/transactions', { params });
export const getTransaction = (id) => api.get(`/expenses/transactions/${id}`);
export const createTransaction = (data) => api.post('/expenses/transactions', data);
export const updateTransaction = (id, data) => api.put(`/expenses/transactions/${id}`, data);
export const deleteTransaction = (id) => api.delete(`/expenses/transactions/${id}`);
export const createTransfer = (data) => api.post('/expenses/transfers', data);

// Accounts
export const listAccounts = () => api.get('/expenses/accounts');
export const createAccount = (data) => api.post('/expenses/accounts', data);
export const updateAccount = (id, data) => api.put(`/expenses/accounts/${id}`, data);
export const deleteAccount = (id) => api.delete(`/expenses/accounts/${id}`);

// Categories
export const listCategories = () => api.get('/expenses/categories');
export const createCategory = (data) => api.post('/expenses/categories', data);
export const createSubcategory = (data) => api.post('/expenses/subcategories', data);

// Budgets
export const listBudgets = () => api.get('/expenses/budgets');
export const createBudget = (data) => api.post('/expenses/budgets', data);
export const updateBudget = (id, data) => api.put(`/expenses/budgets/${id}`, data);
export const deleteBudget = (id) => api.delete(`/expenses/budgets/${id}`);

// Goals
export const listGoals = () => api.get('/expenses/goals');
export const createGoal = (data) => api.post('/expenses/goals', data);
export const updateGoal = (id, data) => api.put(`/expenses/goals/${id}`, data);
export const deleteGoal = (id) => api.delete(`/expenses/goals/${id}`);

// Subscriptions
export const listSubscriptions = () => api.get('/expenses/subscriptions');
export const createSubscription = (data) => api.post('/expenses/subscriptions', data);
export const updateSubscription = (id, data) => api.put(`/expenses/subscriptions/${id}`, data);
export const deleteSubscription = (id) => api.delete(`/expenses/subscriptions/${id}`);

// Recurring
export const listRecurring = () => api.get('/expenses/recurring');
export const createRecurring = (data) => api.post('/expenses/recurring', data);
export const updateRecurring = (id, data) => api.put(`/expenses/recurring/${id}`, data);
export const deleteRecurring = (id) => api.delete(`/expenses/recurring/${id}`);

// AI
export const parseNaturalLanguage = (text) => api.post('/expenses/ai/parse-text', { text });
export const parseImage = (imageBase64, mimeType) => api.post('/expenses/ai/parse-image', { image_base64: imageBase64, mime_type: mimeType });
export const chatAiAssistant = (message) => api.post('/expenses/ai/chat', { message });
export const getAiSettings = () => api.get('/expenses/ai/settings');
export const updateAiSettings = (data) => api.put('/expenses/ai/settings', data);
export const testAiKey = (gemini_api_key) => api.post('/expenses/ai/test-key', { gemini_api_key });
export const removeAiKey = () => api.delete('/expenses/ai/key');

// Import
export const confirmImport = (data) => api.post('/expenses/import/confirm', data);
